import * as React from 'react';
import { EMPTY_TEXT, WhiteLabelMobileSpeechBox } from '@mitchell/react.component.ux';
import { TranslationService } from "../../common";
import { PhotoCaptureConstants, ADDITIONAL_PHOTOS_TEXT, NOTE } from '../constants';
import { PhotoCapture, PhotoCaptureAssignmentSubTypes, PhotoCaptureAssignmentTypes, PhotoCaptureImageDescription } from '../enums';
import { getNavigationMultipleButtonProps } from '../utilities';
import { usePhotoCaptureWorker } from '../hooks';
import { StyledDivAvatarSpechBoxLayout } from './intelligentComponents/IntelligentScriptQuestion.style';
import { IntelligentPBEContainerComponent } from './intelligentComponents';
import { PhotoCaptureThumbnailGallery } from './PhotoCaptureThumbnailGallery';
import { StyledContent, StyledActionControlsSection } from './SinglePhotoUploadComponent.style';
import { StyledDivAdditionalPhotosContainer } from './AdditionalPhotosComponent.style';
import { PhotoCaptureMultiCommentComponent } from './PhotoCaptureMultiCommentComponent';
export const AdditionalPhotosComponent = ({ language, categories, appTheme, questionText, isSaveSuccess, companyCode, evaluationDocId, questionnaireId, questionnaireQuestionId, attachments, questionSubType, contextId, isContextUpdated, photoCaptureAttachmentInfo, isTermsAndConditionAccepted, assignmentType, assignmentSubType, warningMessage, imageMaxWidth, parentQuestionId, fileSizeLimit, attachedArtifactIds, photoCaptureAttachmentDataAction, photoCaptureUpdateAttachedArtifactIdSuccessAction, photoCaptureUpdateContextDataAction, questionnaireEvaluationQuestionGetAction, questionnaireEvaluationSaveRequestAction, photoCaptureResetContextAction, photoCaptureFileUploadFailedAction, photoCaptureIsFileUploadStartedAction, disableLibrary = PhotoCaptureConstants.N, personaConfiguration, shouldShowCommentBox, maxFileCount, isMic, onClose }) => {
    const { imageData, moveNext, movePrevious, setImageData, setIsImageUpdated } = usePhotoCaptureWorker({
        companyCode,
        attachments,
        questionSubType: questionSubType,
        questionnaireQuestionId,
        isSaveSuccess,
        evaluationDocId,
        questionnaireId,
        contextId,
        isContextUpdated,
        photoCaptureAttachmentInfo,
        isTermsAndConditionAccepted,
        assignmentSubType,
        assignmentType,
        parentQuestionId,
        attachedArtifactIds,
        questionnaireEvaluationQuestionGetAction,
        photoCaptureResetContextAction,
        questionnaireEvaluationSaveRequestAction,
        photoCaptureUpdateContextDataAction,
        photoCaptureAttachmentDataAction,
        photoCaptureUpdateAttachedArtifactIdSuccessAction
    });
    const { speechBoxBackgroundColor, finishButtonColor, finishButtonTextColor } = appTheme;
    const translateFn = TranslationService.translate;
    const [isFinishButtonDisabled, setIsFinishButtonDisabled] = React.useState(false);
    const [limitWarningMessage, setLimitWarningMessage] = React.useState(EMPTY_TEXT);
    const [showCarousel, setShowCarousel] = React.useState(false);
    const [isMultiCommentOpen, setIsMultiCommentOpen] = React.useState(false);
    const [multiCommentText, setMultiCommentText] = React.useState({});
    const [multiCommentImageData, setMultiCommentImageData] = React.useState([]);
    React.useEffect(() => {
        if (imageData.length === 0) {
            switch (assignmentType) {
                case PhotoCaptureAssignmentTypes.REQ_ADDITIONAL_PHOTO:
                    setIsFinishButtonDisabled(true);
                    break;
                case PhotoCaptureAssignmentTypes.GENRIC_PHOTO_CAPTURE:
                    assignmentSubType === PhotoCaptureAssignmentSubTypes.RP && setIsFinishButtonDisabled(true);
                    break;
                default:
                    setIsFinishButtonDisabled(false);
            }
        }
        else {
            setIsFinishButtonDisabled(false);
        }
    }, [assignmentType, assignmentSubType, imageData.length]);
    React.useEffect(() => {
        onClose && onClose();
    }, []);
    const onAllFilesUploadComplete = (filesData) => {
        setImageData(filesData);
        if (filesData.length) {
            setIsImageUpdated(true);
        }
        else {
            setIsImageUpdated(false);
        }
    };
    const getUpdatedQuestionText = (language) => {
        if (categories) {
            if (!language || !categories.hasOwnProperty(language)) {
                language = 'en-US'; // Default language
            }
            if (assignmentType === PhotoCaptureAssignmentTypes.REQ_ADDITIONAL_PHOTO && Object.keys(categories).length) {
                const categoryvalue = categories[language];
                if (Array.isArray(categoryvalue) && categoryvalue.length) {
                    const updatedText = `${questionText}<br/><br/><strong>${translateFn(NOTE)}:-</strong> ${translateFn(ADDITIONAL_PHOTOS_TEXT)} <br /><strong>${categoryvalue.join(', ')}</strong>`;
                    return updatedText;
                }
            }
        }
        return questionText;
    };
    const questionTextCategories = React.useMemo(() => getUpdatedQuestionText(language), [language]);
    const handleErrorMessage = (value) => {
        setLimitWarningMessage(value);
    };
    const multipleButtonProps = Object.assign(Object.assign(Object.assign({}, getNavigationMultipleButtonProps({
        appTheme: Object.assign(Object.assign({}, appTheme), { selectedButtonBackgroundColor: appTheme.buttonBackgroundColor }),
        onLeftClick: () => movePrevious && movePrevious(),
        onRightClick: () => moveNext(!imageData.length)
    })), { rightButtonLabel: PhotoCaptureConstants.FINISH, shouldNextButtonDisabled: isFinishButtonDisabled, finishButtonBackgroundColor: finishButtonColor, finishButtonTextColor: finishButtonTextColor }), (!isMic && {
        leftButtonLabel: PhotoCaptureConstants.PREVIOUS,
        leftButtonIcon: ''
    }));
    const onChangeCarouselCommentText = (updatedIndex, value) => {
        const existingImageData = [...imageData];
        existingImageData[updatedIndex].commentText = value;
        setImageData(existingImageData);
        setIsImageUpdated(true);
    };
    const onChangeMultiCommentText = (_, value, updatedIndex) => {
        setMultiCommentText(Object.assign(Object.assign({}, multiCommentText), { [updatedIndex]: value }));
    };
    const onProceedMultiComment = () => {
        setIsMultiCommentOpen(false);
        let isAnyCommentUpdated = false;
        const updatedImageData = imageData.map((item, index) => {
            if (multiCommentText.hasOwnProperty(index)) {
                isAnyCommentUpdated = true;
                return Object.assign(Object.assign({}, item), { commentText: multiCommentText[index] });
            }
            return item;
        });
        if (isAnyCommentUpdated) {
            setIsImageUpdated(isAnyCommentUpdated);
            setImageData(updatedImageData);
        }
    };
    const onHandleMultiCommentBoxButton = () => {
        if (!isMultiCommentOpen) {
            setMultiCommentImageData(imageData.map((image, index) => ({
                title: PhotoCaptureImageDescription.PHOTO_DESCRIPTION,
                fileInputAppendedId: `damagePhoto_${index}`,
                imageDescription: `${image.fileDescription}_${index}`,
                imageContent: image
            })));
        }
        setIsMultiCommentOpen(!isMultiCommentOpen);
        setMultiCommentText({});
    };
    return (React.createElement(React.Fragment, null, !isMultiCommentOpen ? (React.createElement(IntelligentPBEContainerComponent, Object.assign({ islanguageHide: true, appTheme: appTheme, isDeviceLibDisabled: false, btnLabel: TranslationService.translate(PhotoCaptureConstants.FINISH), isFooter: isMic && !showCarousel, warningMessage: limitWarningMessage, hasMultipleButton: !isMic && !showCarousel, isBtnDisabled: isFinishButtonDisabled }, (isMic && { movePrevious: () => movePrevious && movePrevious() }), { moveNext: moveNext, multipleButtonProps: multipleButtonProps, shouldAllowMitchellIntelligent: isMic }),
        React.createElement(StyledContent, null,
            React.createElement(StyledDivAvatarSpechBoxLayout, null,
                React.createElement(WhiteLabelMobileSpeechBox, { speechBoxRichText: questionTextCategories, speechBoxBackgroundColor: speechBoxBackgroundColor })),
            React.createElement(StyledActionControlsSection, null,
                React.createElement(StyledDivAdditionalPhotosContainer, null,
                    React.createElement(PhotoCaptureThumbnailGallery, { galleryId: `${PhotoCapture.GUIDED_PHOTO_CAPTURE}_photoCaptureThumbnailGallery`, companyCode: companyCode, filesData: imageData, scaledMaxSize: imageMaxWidth, onAllFilesUploaded: onAllFilesUploadComplete, photoCaptureAttachmentInfo: photoCaptureAttachmentInfo, photoCaptureFileUploadFailedAction: photoCaptureFileUploadFailedAction, photoCaptureIsFileUploadStartedAction: photoCaptureIsFileUploadStartedAction, disableLibrary: disableLibrary, parentQuestionId: parentQuestionId, fileSizeLimit: fileSizeLimit, questionnaireQuestionId: questionnaireQuestionId, personaConfiguration: personaConfiguration, setWarningMessage: handleErrorMessage, maxFileCount: maxFileCount, showCarousel: showCarousel, setShowCarousel: setShowCarousel, onChangeHandleCommentText: onChangeCarouselCommentText, shouldShowCommentBox: shouldShowCommentBox, onHandleMultiCommentBoxButton: onHandleMultiCommentBoxButton })))))) : (React.createElement(PhotoCaptureMultiCommentComponent, { headerText: appTheme.headerText, headerBackgroundColor: appTheme.headerBackgroundColor, headerColor: appTheme.headerColor, buttonBackgroundColor: appTheme.buttonBackgroundColor, buttonTextColor: appTheme.buttonTextColor, shouldNextButtonDisabled: !imageData.length, disabledButtonBackgroundColor: appTheme.disabledButtonBackgroundColor, disabledButtonTextColor: appTheme.disabledButtonTextColor, onLeftClick: onHandleMultiCommentBoxButton, onRightClick: onProceedMultiComment, imageData: multiCommentImageData, onChangeHandleCommentText: onChangeMultiCommentText, isCommonTitle: true }))));
};
//# sourceMappingURL=AdditionalPhotosComponent.js.map